<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import {
  getVoiceCallProvider,
  VOICE_CALL_PROVIDERS,
} from 'dashboard/helper/inbox';

import Button from 'dashboard/components-next/button/Button.vue';
import DialpadDialog from 'dashboard/components-next/Dialpad/DialpadDialog.vue';

defineProps({
  isEffectivelyCollapsed: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const dialpadDialogRef = ref(null);

const inboxesList = useMapGetter('inboxes/getInboxes');

// Cold-calling a number with no existing conversation only works through a
// Twilio voice inbox — WhatsApp's /initiate is conversation-scoped, so it
// can't originate a call to a brand-new number (see calls_controller.rb,
// which requires channel_type: 'Channel::TwilioSms').
const voiceInboxes = computed(() =>
  (inboxesList.value || []).filter(
    inbox => getVoiceCallProvider(inbox) === VOICE_CALL_PROVIDERS.TWILIO
  )
);
const hasVoiceInboxes = computed(() => voiceInboxes.value.length > 0);

const openDialpad = () => {
  dialpadDialogRef.value?.open();
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <span v-if="hasVoiceInboxes" class="contents">
    <Button
      v-tooltip.top-end="t('DIALPAD.BUTTON_LABEL')"
      :aria-label="t('DIALPAD.BUTTON_LABEL')"
      icon="i-material-symbols-dialpad"
      color="slate"
      size="sm"
      class="dark:hover:!bg-n-slate-9/30"
      :class="
        isEffectivelyCollapsed
          ? '!size-11 !rounded-full !outline-none !text-n-slate-11'
          : '!h-8 !outline-n-weak !text-n-slate-11'
      "
      @click="openDialpad"
    />
    <DialpadDialog ref="dialpadDialogRef" :voice-inboxes="voiceInboxes" />
  </span>
</template>
